import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from './BaseSwitcher.module.css';
import { setBaseDetails,selectBaseDataSet } from "../../../features/layers/baselayerslice";

const BaseSwitcher = () => {
  const dispatch = useDispatch();
  const basedata = useSelector(selectBaseDataSet);
  const changeMap = useCallback((e) => {
    dispatch(setBaseDetails({ data: e, show: true }));
  }, [dispatch]);
  return (
    <ul className={classes.switchbase}>
      {basedata.map((baselayer) => (
        <li key={baselayer.id} onClick={() => changeMap(baselayer.id)}>
          <img className={classes.baseimage} src={baselayer.image} />
        </li>
      ))}
    </ul>
  );
};

export default BaseSwitcher;
